import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';

const ParkingAdminLayout = () => {
    return (
        <MainLayout>
            <Outlet />
        </MainLayout>
    );
};

export default ParkingAdminLayout;
